/* tslint:disable */
/* eslint-disable */
/**
 * LPPSWebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { formatDateOnly, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PublishPricesRequestBody
 */
export interface PublishPricesRequestBody {
    /**
     * 
     * @type {boolean}
     * @memberof PublishPricesRequestBody
     */
    confirmed?: boolean;
}

/**
 * Check if a given object implements the PublishPricesRequestBody interface.
 */
export function instanceOfPublishPricesRequestBody(value: object): value is PublishPricesRequestBody {
    return true;
}

export function PublishPricesRequestBodyFromJSON(json: any): PublishPricesRequestBody {
    return PublishPricesRequestBodyFromJSONTyped(json, false);
}

export function PublishPricesRequestBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PublishPricesRequestBody {
    if (json == null) {
        return json;
    }
    return {
        
        'confirmed': json['confirmed'] == null ? undefined : json['confirmed'],
    };
}

export function PublishPricesRequestBodyToJSON(json: any): PublishPricesRequestBody {
    return PublishPricesRequestBodyToJSONTyped(json, false);
}

export function PublishPricesRequestBodyToJSONTyped(value?: PublishPricesRequestBody | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'confirmed': value['confirmed'],
    };
}

